module.exports = ".row:nth-child(odd){\r\n    background: #ececec;\r\n}\r\n\r\n.row{\r\n    padding:9px 0px 0px !important;\r\n}\r\n\r\n.error-msg{\r\n    margin-top:-4px;\r\n}\r\n\r\n.input-group label{\r\n    width:100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/Finance/sub-head/sub-head.component.css
// module id = ./src/app/Finance/sub-head/sub-head.component.css
// module chunks = main